<template>
  <div class="input-group">
    <select
      :value="filterOperator"
      class="form-select"
      style="max-width: 120px"
      @change="onFilterOperatorChange($event.target.value)"
    >
      <option value="=">{{ $t('Equal to') }}</option>
      <option value="!=">{{ $t('Different from') }}</option>
      <option value="is_null">{{ $t('Is empty') }}</option>
      <option value="is_not_null">{{ $t('Is not empty') }}</option>
    </select>
    <select
      :id="computedFieldId"
      class="form-select"
      :value="displayValue"
      :disabled="filterOperator === 'is_null' || filterOperator === 'is_not_null'"
      @change="onFilterValueChange($event.target.value)"
    >
      <option value="">{{ placeholder || "Seleccione..." }}</option>
      <option
        v-for="opt in field.options"
        :key="opt.value"
        :value="opt.value"
      >
        {{ $t(opt.label) || opt.label }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "FilterFieldSelect",
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: [String, Number, Boolean, Array],
      default: null,
    },
    fieldId: {
      type: String,
      default: null,
    },
    filterOperator: {
      type: String,
      default: "=",
    },
  },
  computed: {
    displayValue() {
      if (this.value !== null && this.value !== undefined && this.value !== "") {
        return this.value;
      }
      return null;
    },
    placeholder() {
      return this.field.label || this.field.key || "";
    },
    computedFieldId() {
      return this.fieldId || `filter-select-${this.field.key}`;
    },
  },
  methods: {
    onFilterOperatorChange(operator) {
      this.$emit("filter-operator-change", operator);
    },
    onFilterValueChange(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>

<style scoped>
.input-group {
  width: 100%;
}
</style>

